const deps = [];

const maintainScrollBottomDirective = () => ({
  restrict: 'A',
  scope: false,
  link(scope, elem) {
    const tolerableSmoothScrollThreshhold = 500;
    const smoothScrollDuration = 400;

    scope.$scrollToBottom = (duration = 0) => {
      // eslint-disable-line no-param-reassign
      elem.stop().animate({ scrollTop: elem[0].scrollHeight }, duration);
    };

    const wasAtBottom = (scrollHeightDiff = 0, offsetHeightDiff = 0) => {
      const scrollPos = elem[0].scrollTop;
      const oldElementHeight = elem[0].offsetHeight - offsetHeightDiff;
      const oldScrollHeight = elem[0].scrollHeight - scrollHeightDiff;

      return oldElementHeight + scrollPos >= oldScrollHeight;
    };

    // When new messages are added and the scroll height changes
    scope.$watch(
      () => elem[0].scrollHeight,
      (newHeight, oldHeight) => {
        const diff = newHeight - oldHeight;
        if (diff <= 0 || !wasAtBottom(diff, 0)) return;

        scope.$$postDigest(() => {
          scope.$scrollToBottom(diff < tolerableSmoothScrollThreshhold ? smoothScrollDuration : 0);
        });
      },
    );

    // When the element height is changed (i.e. window resize)
    scope.$watch(
      () => elem[0].offsetHeight,
      (newHeight, oldHeight) => {
        const diff = newHeight - oldHeight;
        if (!wasAtBottom(0, diff)) return;

        scope.$scrollToBottom();
      },
    );
  },
});

module.exports = angular
  .module('bench.ui.web.maintainScrollBottom', deps)
  .directive('blMaintainScrollBottom', maintainScrollBottomDirective);
